import React from "react";
import "./ButtonContact.css";
import { Link } from "react-router-dom";
import ROUTES from "../Hooks/RoutesDynamic/RoutesDynamic";
import { useLocation } from "react-router-dom";
import HButtonBG from "../../Assets/Svg/Header/HButtonBG.svg";

export default function ButtonContact({ isScrolled, Text, Path }) {
  const location = useLocation();
  const isArabic = location.pathname.endsWith("/ar");
  return (
    <Link to={Path} className="Contact_Text">
      <button className={`Contact_Button ${isArabic ? "arabic" : "english"} ${isScrolled ? "CBTscrolled" : ""}`}>
        <div>
          <img src={HButtonBG} alt="" className="HButtonBGImg" />
        </div>
        <div className={`HButtonBGButton ${isArabic ? "arabic" : "english"}`}>{Text}</div>
      </button>
    </Link>
  );
}
